import { QueryClient } from '@tanstack/react-query';

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        // An auth/validation failure won't fix itself on retry; only retry likely-transient failures once.
        retry: (failureCount, error) => {
          const status = (error as { status?: number } | null)?.status;
          if (status !== undefined && status >= 400 && status < 500) return false;
          return failureCount < 1;
        },
        refetchOnWindowFocus: false,
      },
    },
  });
